import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AiDescriptionTools({ getFacts, onPick, disabled, testIdPrefix = "ai-desc" }) {
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    const facts = getFacts();
    if (!facts) return;
    setBusy(true);
    try {
      const r = await api.post("/cars/generate-description", facts);
      if (r.data.description) {
        onPick(r.data.description);
        toast.success("Listing drafted — tweak anything you'd like before saving");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't draft the listing right now");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={generate}
      disabled={busy || disabled}
      className="rounded-sm gap-1"
      data-testid={`${testIdPrefix}-generate`}
    >
      <Sparkles className="h-3 w-3" /> {busy ? "Writing your listing…" : "Generate Listing with AI"}
    </Button>
  );
}
